import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import ScreenContainer from './screen-container'

const Screen = (props) => {
  const history = useHistory()
  const location = useLocation()

  return (
    <ScreenContainer
      {...props}
      history={history}
      location={location}
    />
  )
}

export default Screen
